import React from 'react';

type Props = { children: React.ReactNode };

type State = { hasError: boolean; error?: Error };

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Global Error Boundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-background text-foreground">
          <div className="max-w-md text-center space-y-3">
            <h1 className="text-lg font-semibold">Something went wrong</h1>
            <p className="text-sm text-muted-foreground">
              The UI failed to render due to a runtime error.
            </p>
            {this.state.error && (
              <div className="mt-4 p-4 bg-muted/50 rounded-lg text-left overflow-auto max-h-[200px]">
                <p className="text-xs font-mono text-rose-500 font-bold mb-1">
                  Error: {this.state.error.message}
                </p>
                <p className="text-[10px] font-mono text-muted-foreground whitespace-pre">
                  {this.state.error.stack}
                </p>
              </div>
            )}
            <button
              className="inline-flex items-center justify-center rounded-md border border-border px-3 py-2 text-sm"
              onClick={() => window.location.reload()}
            >
              Refresh
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

